import { render, staticRenderFns } from "./ModalDeleteBundle.vue?vue&type=template&id=405db131"
import script from "./ModalDeleteBundle.vue?vue&type=script&lang=js"
export * from "./ModalDeleteBundle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports